/* ==========================================================================
   VM · UpCart-brug (29-aug-2026)

   Wordt alleen geladen als de thema-instelling "UpCart als winkelwagen
   gebruiken" AAN staat (zie layout/theme.liquid). UpCart's app-embed
   onderschept dan zelf:
     - submits van form[action*="/cart/add"]  → PDP-knop, sticky ATC en
       eventuele sectie-ATC's (alle lopen via het productformulier);
     - kliks op a[data-cart-toggle]           → het carticoon in de header.
   Daar hoeft dit bestand dus niets voor te doen. Wat hier wél gebeurt:

   1) de cart-badge in de header ([data-cart-count]) bijwerken zodra UpCart
      de winkelwagen laadt of wijzigt — cart-drawer.js (dat dit deed) is in
      UpCart-modus niet geladen;
   2) een vangnet op het carticoon: is UpCart's API aanwezig, dan openen we
      de drawer expliciet (upcartOpenCart is idempotent, dubbel openen kan
      geen kwaad); is UpCart (nog) niet geladen, dan loopt de klik gewoon
      door naar /cart.

   De upcartSubscribe*-functies bestaan pas nadat de UpCart-bundle (async)
   geladen is; daarom kort pollen i.p.v. één keer checken.
   ========================================================================== */
(function () {
  'use strict';

  function badgeBijwerken(cart) {
    var count = null;
    if (cart && typeof cart.item_count === 'number') {
      count = cart.item_count;
    } else if (cart && Object.prototype.toString.call(cart.items) === '[object Array]') {
      count = cart.items.reduce(function (som, regel) {
        return som + (Number(regel.quantity) || 0);
      }, 0);
    }
    if (count === null) return;

    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = count;
      nodes[i].hidden = count === 0;
    }
  }

  var geabonneerd = false;
  function abonneren() {
    if (geabonneerd) return true;
    if (typeof window.upcartSubscribeCartLoaded !== 'function' ||
        typeof window.upcartSubscribeCartUpdated !== 'function') {
      return false;
    }
    geabonneerd = true;
    window.upcartSubscribeCartLoaded(badgeBijwerken);
    window.upcartSubscribeCartUpdated(badgeBijwerken);
    return true;
  }

  if (!abonneren()) {
    var pogingen = 0;
    var timer = setInterval(function () {
      if (abonneren() || ++pogingen > 80) clearInterval(timer);
    }, 250);
  }

  /* De embed zet de actuele cart al in de HTML: badge meteen goed zetten. */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.upcartPreloadedCart) badgeBijwerken(window.upcartPreloadedCart);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-cart-toggle]');
    if (!trigger) return;
    if (typeof window.upcartOpenCart !== 'function') return; /* geen UpCart: gewoon naar /cart */
    event.preventDefault();
    window.upcartOpenCart();
  });
})();
